import React, { useContext, useRef, useEffect, useState, useCallback } from 'react';
import { WorkSpaceRegion } from '../../Types/HomePageInterface'
import { getBaseUrl } from '../../Utils';
import DetailedTooltip from '../../GenericComponents/Tooltip/DetailedTooltip'
import WorkspaceDropdown from './TileDropDown';
import WorkspaceActionsDropdown from '../Workspace/workspaceActionsDropdown';
import { HomeContext } from './Home';
import { FoundationsEnums } from "../../enum";
import { getColorClassFromRgb } from './HomeUtils'
import { useSelector } from 'react-redux';
import { getCurrentUserData, RootState } from '../../Redux/store';
import { checkType1 } from '../../GlobalMethods';
import { useNavigate } from 'react-router-dom';
import { useWorkspaceStore } from '../Workspace/workspaceContext';
import { WorkspaceApiDTO_Workspace } from '../../Interfaces/APIContracts/WorkspaceApiDTO_Workspace';



const baseUrl = `${getBaseUrl()}ux/index.html#workspace/`;

const WorkspaceRegion: React.FC<WorkSpaceRegion> = ({ HomeWorkspaceTiles, isVisible, index, isDragging, onWorkspaceNameUpdate }) => {

  const currentWorkspaceData: WorkspaceApiDTO_Workspace = useWorkspaceStore((s) => s.workspaceState);
  const tileRef = useRef(null);
  const navigate = useNavigate();

  const redirectToWorkspace = (e: React.MouseEvent) => {
    e.preventDefault();
    if (HomeWorkspaceTiles.wsid) {
      navigate(`${location.pathname}${location.search}#workspace/${HomeWorkspaceTiles.wsid}`, { replace: true });

      // window.location.href = `${baseUrl}${HomeWorkspaceTiles.wsid}`;
    }
  }
  const isFavorites: boolean = HomeWorkspaceTiles.WorkspaceId == 0 ? true : false;
  const [numberOfLinks, setNumberOfLinks] = useState<number>(0);

  const context = useContext(HomeContext);
  const {
    DetachThisWorkspaceDialog,
    setDetachThisWorkspaceDialog,
    EditThisWorkspaceDialog,
    setEditThisWorkspaceDialog,
    ShareThisWorkspaceDialog,
    setShareThisWorkspaceDialog,
    DeleteThisWorkspaceDialog,
    setDeleteThisWorkspaceDialog,
    WorkspaceIdforDialog,
    setWorkspaceIdforDialog,
    DialogMsg,
    setDialogMsg,
    rgborname_color,
    setrgborname_color,
    currentUsersData,
    editCallback,
    WorkSpaceDetails,
    SetWorkSpaceDetails,
  } = context || {};

  const currentUserData = useSelector(
    (state: RootState) => getCurrentUserData(state)
  )

    useEffect(() => {
      onWorkspaceNameUpdate(currentWorkspaceData?.WorkspaceId, currentWorkspaceData?.Name, currentWorkspaceData?.Description, currentWorkspaceData?.PrivacyLock);
    }, [currentWorkspaceData?.Name, currentWorkspaceData?.Description, currentWorkspaceData?.PrivacyLock]);

  const isWorkspaceSharedWithAnotherNonAdminAndNonCreatorUser = () => {
    if (HomeWorkspaceTiles?.ShareType === FoundationsEnums.DashBoardShareType.ByRole) {
      return false;
    }
    if (currentUserData?.id !== HomeWorkspaceTiles?.CreatedByUserId) {
      return !checkType1(currentUserData) && !currentUserData?.privileges.includes('CustomerAdmin');
    }
    return false;
  }
  const isAdminUserProxyingAsANonAdminNonCreator = () => {
    const isAdminProxying = (!checkType1(currentUserData) && !currentUserData?.privileges.includes('CustomerAdmin'))
      && HomeWorkspaceTiles.CreatedByUserId !== currentUserData?.id;
    return isAdminProxying;
  }
  const isShareWorkspace = useCallback(() => {
    if (isWorkspaceSharedWithAnotherNonAdminAndNonCreatorUser()) {
      return currentUserData.privileges.includes('Workspace_Share') && HomeWorkspaceTiles?.Privacy !== FoundationsEnums.PrivacyLock.PrivateNotVisible;
    }
    else {
      return currentUserData.privileges.includes('Workspace_Share');
    }
  }, [])
  const canDetachWorkspace = useCallback((appGUID?: string) => {
    if (appGUID === null || appGUID === '' || appGUID === undefined) {
      if (currentUserData.privileges.includes('Workspace_Detach') && HomeWorkspaceTiles?.Privacy === FoundationsEnums.PrivacyLock.OpenUnlocked) {
        return true;
      }
      return false;
    }
    return false;
  }, [])
  const canDeleteWorkspace = useCallback((appGUID?: string) => {
    if (appGUID === null || appGUID === '' || appGUID === undefined) {
      if (currentUserData.privileges.includes('Workspace_Delete') && HomeWorkspaceTiles?.Privacy === FoundationsEnums.PrivacyLock.OpenUnlocked) {
        return true;
      }
      return false;
    }
    return false;
  }, [])

  const canEditWorkspace = useCallback(() => {
    if (isWorkspaceSharedWithAnotherNonAdminAndNonCreatorUser()) {
      return currentUserData.privileges.includes('Workspace_Edit') && HomeWorkspaceTiles?.Privacy !== FoundationsEnums.PrivacyLock.PrivateNotVisible;
    } else if (isAdminUserProxyingAsANonAdminNonCreator()) {
      return currentUserData.privileges.includes('Workspace_Edit') && HomeWorkspaceTiles?.Privacy === FoundationsEnums.PrivacyLock.OpenUnlocked;
    }
    else {
      return currentUserData.privileges.includes('Workspace_Edit');
    }
  }, [])
  useEffect(() => {
    let links = 0;
    let isDeleteWorkspace = false;
    if (canEditWorkspace()) {

      links++;
    }
    if (canDeleteWorkspace()) {
      isDeleteWorkspace = true;
      links++;
    }
    if (canDetachWorkspace()) {
      links++;
    }
    if (isShareWorkspace()) {
      links++;
    }
    setNumberOfLinks(links);
  }, [canEditWorkspace, canDeleteWorkspace, canDetachWorkspace, isShareWorkspace]);
  return (
    <>

      <div id={`dashboard_tab_9_${HomeWorkspaceTiles.WorkspaceId}`} className={`col-md-6 col-xl-3 workspace-item ${HomeWorkspaceTiles.WorkspaceId === 0 ? "disable-sort-item" : "ui-sortable-handle"} ${isVisible ? '' : 'hide'}`}>
        <div ref={tileRef} id={`dashboard_tab_2_${HomeWorkspaceTiles.WorkspaceId}`}
          data-id={`${HomeWorkspaceTiles.WorkspaceId}`}
          className={`dashboard-tab-base click_to_redirect_detail dashboard-tab-tile-${index % 3} ${HomeWorkspaceTiles.WorkspaceId !== 0 && HomeWorkspaceTiles.rgborname_color ? getColorClassFromRgb(HomeWorkspaceTiles.rgborname_color) : ""}`}
          data-hasqtip={`${HomeWorkspaceTiles.WorkspaceId}`}
        >
          <DetailedTooltip
            key={`${HomeWorkspaceTiles.WorkspaceId}`}
            content={{
              Name: HomeWorkspaceTiles.Name,
              Description: HomeWorkspaceTiles.Description || '',
            }}
            placement="bottom-start"
            animation="shift-away-subtle"
            allowHTML={true}
            showIcon={false}
            targetEl={`row mx-0 tab-wrapper h-100`}
            trigger={"mouseenter focus"}
            delay={[100, 0]}
            interactiveOverride={false}
          >

            <div className={`row mx-0 tab-wrapper h-100${isVisible ? '' : 'hide'}`} onClick={redirectToWorkspace} style={{ cursor: 'pointer' }}>
              <div className="col-12 px-0 db-name">
                {/* <span id={`wptile_dashboard_name_${HomeWorkspaceTiles.WorkspaceId}`}>{HomeWorkspaceTiles.Name}</span> */}
                <span
                  id={`wptile_dashboard_name_${HomeWorkspaceTiles.WorkspaceId}`}
                  dangerouslySetInnerHTML={{
                    __html: HomeWorkspaceTiles.Name,
                  }}
                />
                <span className="workspace_menu_icon" style={{
                  position: 'absolute',
                  top: '10px',
                  right: '15px',
                  pointerEvents: 'auto'
                }}>
                  {HomeWorkspaceTiles.WorkspaceId !== 0 ? (
                    numberOfLinks > 0 ? (<WorkspaceDropdown
                      id={HomeWorkspaceTiles.WorkspaceId}
                      dataToggleElType="anchor"
                      dataLastUpdatedByUserId="0"// Update
                      dataPrivacy="0"// Update
                      dataCreatedByUserId="0"// Update
                      dataMenuType="PopUp"
                      dataShareType={`${HomeWorkspaceTiles.ShareType}`}
                      dataToggleClass="noclick"
                      dataToggleIconClass="workspace-three-dots-vertical"
                      dataWorkspaceId={HomeWorkspaceTiles.WorkspaceId}
                      dataCurrentColor={`${HomeWorkspaceTiles.rgborname_color}`}
                      dataWsid={`${HomeWorkspaceTiles.wsid}`}
                      HomeWorkspaceTiles={HomeWorkspaceTiles}
                      dataWorkspaceName={HomeWorkspaceTiles.Name}
                      dataWorkspaceDescription={HomeWorkspaceTiles.Description}
                      dataWorkspacePrivacyLock={HomeWorkspaceTiles.PrivacyLock ??HomeWorkspaceTiles.Privacy}
                      tileRef={tileRef}
                    />) : null
                  ) : null}
                  {/* <WorkspaceActionsDropdown id={HomeWorkspaceTiles.WorkspaceId} isHomePopUp={true} /> */}

                </span>
                {!isFavorites && numberOfLinks !== 0 && (
                  <span
                    className="workspace_menu_icon"
                    data-workspace-id={`${HomeWorkspaceTiles.WorkspaceId}`}
                    style={{ position: "absolute", top: "10px", right: "15px" }}
                  >
                    {/* Insert dropdown or menu component here */}
                  </span>
                )}
              </div>

              <div className='col-12 px-0 db-desc mb-auto mt-0' id={`dashboard_description_${HomeWorkspaceTiles.WorkspaceId}`}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: HomeWorkspaceTiles.Description,
                  }}
                />
              </div>

              <div className="vu-count col-12 px-0 mt-auto pt-auto">
                {HomeWorkspaceTiles.NumberOfVUs} {HomeWorkspaceTiles.NumberOfVUs === 1 ? 'report ' : 'reports '}

                {(HomeWorkspaceTiles.SharedUsersCount === 0 && HomeWorkspaceTiles.SharedRolesCount === 0) ? (
                  <>&nbsp;Personal&nbsp;</>
                ) : (
                  <>
                    {HomeWorkspaceTiles.SharedRolesCount !== 0 ? (
                      <>
                        shared with {HomeWorkspaceTiles.SharedRolesCount}{" "}
                        {HomeWorkspaceTiles.SharedRolesCount === 1 ? "role" : "roles"}
                        {HomeWorkspaceTiles.SharedUsersCount !== 0 && (
                          <>
                            {" "}and {HomeWorkspaceTiles.SharedUsersCount}{" "}
                            {HomeWorkspaceTiles.SharedUsersCount === 1 ? "user" : "users"}
                          </>
                        )}
                      </>
                    ) : (
                      HomeWorkspaceTiles.SharedUsersCount !== 0 && (
                        <>
                          shared with {HomeWorkspaceTiles.SharedUsersCount}{" "}
                          {HomeWorkspaceTiles.SharedUsersCount === 1 ? "user" : "users"}
                        </>
                      )
                    )}
                  </>
                )}
              </div>
            </div>
          </DetailedTooltip>
        </div>
      </div>
    </>
  );
};


export default WorkspaceRegion;
